import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{body-class "user-preferences-page"}}

<div class="user-navigation user-navigation-secondary">
  <HorizontalOverflowNav @ariaLabel="User secondary - preferences">
    <DNavigationItem
      @route="preferences.account"
      @ariaCurrentContext="subNav"
      class="user-nav__preferences-account"
    >
      {{d-icon "user"}}
      <span>{{i18n "user.preferences_nav.account"}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="preferences.security"
      @ariaCurrentContext="subNav"
      class="user-nav__preferences-security"
    >
      {{d-icon "lock"}}
      <span>{{i18n "user.preferences_nav.security"}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="preferences.profile"
      @ariaCurrentContext="subNav"
      class="user-nav__preferences-profile"
    >
      {{d-icon "user"}}
      <span>{{i18n "user.preferences_nav.profile"}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="preferences.emails"
      @ariaCurrentContext="subNav"
      class="user-nav__preferences-emails"
    >
      {{d-icon "envelope"}}
      <span>{{i18n "user.preferences_nav.emails"}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="preferences.notifications"
      @ariaCurrentContext="subNav"
      class="user-nav__preferences-notifications"
    >
      {{d-icon "bell"}}
      <span>{{i18n "user.preferences_nav.notifications"}}</span>
    </DNavigationItem>

    {{#if this.model.can_change_tracking_preferences}}
      <DNavigationItem
        @route="preferences.tracking"
        @ariaCurrentContext="subNav"
        class="user-nav__preferences-tracking"
      >
        {{d-icon "plus"}}
        <span>{{i18n "user.preferences_nav.tracking"}}</span>
      </DNavigationItem>
    {{/if}}

    <DNavigationItem
      @route="preferences.users"
      @ariaCurrentContext="subNav"
      class="user-nav__preferences-users"
    >
      {{d-icon "users"}}
      <span>{{i18n "user.preferences_nav.users"}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="preferences.interface"
      @ariaCurrentContext="subNav"
      class="user-nav__preferences-interface"
    >
      {{d-icon "desktop"}}
      <span>{{i18n "user.preferences_nav.interface"}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="preferences.navigation-menu"
      @ariaCurrentContext="subNav"
      class="user-nav__preferences-navigation-menu"
    >
      {{d-icon "bars"}}
      <span>{{i18n "user.preferences_nav.navigation_menu"}}</span>
    </DNavigationItem>

    <PluginOutlet
      @name="user-preferences-nav-under-interface"
      @connectorTagName="div"
      @outletArgs={{hash model=this.model}}
    />
    <PluginOutlet
      @name="user-preferences-nav"
      @connectorTagName="li"
      @outletArgs={{hash model=this.model}}
    />
  </HorizontalOverflowNav>
</div>

<section class="user-content user-preferences" id="user-content">
  <span>
    <PluginOutlet
      @name="above-user-preferences"
      @connectorTagName="div"
      @outletArgs={{hash model=this.model}}
    />
  </span>

  <form class="form-vertical">
    {{outlet}}
  </form>
</section>
*/
{
  "id": "lsqn5Ysk",
  "block": "[[[1,[28,[35,0],[\"user-preferences-page\"],null]],[1,\"\\n\\n\"],[10,0],[14,0,\"user-navigation user-navigation-secondary\"],[12],[1,\"\\n  \"],[8,[39,1],null,[[\"@ariaLabel\"],[\"User secondary - preferences\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,2],[[24,0,\"user-nav__preferences-account\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"preferences.account\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"user\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user.preferences_nav.account\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,2],[[24,0,\"user-nav__preferences-security\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"preferences.security\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"lock\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user.preferences_nav.security\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,2],[[24,0,\"user-nav__preferences-profile\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"preferences.profile\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"user\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user.preferences_nav.profile\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,2],[[24,0,\"user-nav__preferences-emails\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"preferences.emails\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"envelope\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user.preferences_nav.emails\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,2],[[24,0,\"user-nav__preferences-notifications\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"preferences.notifications\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"bell\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user.preferences_nav.notifications\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"model\",\"can_change_tracking_preferences\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"user-nav__preferences-tracking\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"preferences.tracking\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"plus\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,4],[\"user.preferences_nav.tracking\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,2],[[24,0,\"user-nav__preferences-users\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"preferences.users\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"users\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user.preferences_nav.users\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,2],[[24,0,\"user-nav__preferences-interface\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"preferences.interface\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"desktop\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user.preferences_nav.interface\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,2],[[24,0,\"user-nav__preferences-navigation-menu\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"preferences.navigation-menu\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"bars\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user.preferences_nav.navigation_menu\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,6],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-preferences-nav-under-interface\",\"div\",[28,[37,7],null,[[\"model\"],[[30,0,[\"model\"]]]]]]],null],[1,\"\\n    \"],[8,[39,6],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-preferences-nav\",\"li\",[28,[37,7],null,[[\"model\"],[[30,0,[\"model\"]]]]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"section\"],[14,0,\"user-content user-preferences\"],[14,1,\"user-content\"],[12],[1,\"\\n  \"],[10,1],[12],[1,\"\\n    \"],[8,[39,6],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"above-user-preferences\",\"div\",[28,[37,7],null,[[\"model\"],[[30,0,[\"model\"]]]]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"form\"],[14,0,\"form-vertical\"],[12],[1,\"\\n    \"],[46,[28,[37,9],null,null],null,null,null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"body-class\",\"horizontal-overflow-nav\",\"d-navigation-item\",\"d-icon\",\"i18n\",\"if\",\"plugin-outlet\",\"hash\",\"component\",\"-outlet\"]]",
  "moduleName": "discourse/templates/preferences.hbs",
  "isStrictMode": false
});